import { render, staticRenderFns } from "./FlipBookImage.vue?vue&type=template&id=2f399a88&scoped=true&"
import script from "./FlipBookImage.vue?vue&type=script&lang=js&"
export * from "./FlipBookImage.vue?vue&type=script&lang=js&"
import style0 from "./FlipBookImage.vue?vue&type=style&index=0&id=2f399a88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f399a88",
  null
  
)

export default component.exports